var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonForm',{attrs:{"field-group":"UsersNew","form-action":"/markets/user","is-visible-required":true}})}
var staticRenderFns = []

export { render, staticRenderFns }